export default __webpack_public_path__ + "static/media/overviewBanner.e8273059.png";